__turbopack_context__.v({
  "ctaButton": "TemokGuarn-module__hXYI-G__ctaButton",
  "description": "TemokGuarn-module__hXYI-G__description",
  "heading": "TemokGuarn-module__hXYI-G__heading",
  "imageBox": "TemokGuarn-module__hXYI-G__imageBox",
  "orange": "TemokGuarn-module__hXYI-G__orange",
  "sectionWrapper": "TemokGuarn-module__hXYI-G__sectionWrapper",
  "subHeading": "TemokGuarn-module__hXYI-G__subHeading",
});
